import Vuex from 'vuex';
import Vue from 'vue';
import CryptoJS from 'crypto-js'
import router from '../router'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedIn: false,
    token:''
  },
  mutations: {
    authState(state, isLogged) {
      state.loggedIn = isLogged;
    },
    saveToken(state,token){
      state.token = token
    }
  },
  actions: {
    authState(context, isLogged) {
      context.commit('authState', isLogged);
    },

    logIn({ commit }, plainTextPwd) {
      var hash = CryptoJS.PBKDF2(plainTextPwd,
        process.env.VUE_APP_PWD_SALT, {
        keySize: 512 / 32,
        iterations: 1000
      }).toString(CryptoJS.enc.Hex);
      if (process.env.VUE_APP_PWD_HASH === hash) {
        commit('authState', true);
        commit('saveToken',plainTextPwd)
        return true
      }
      return false
    },

    Logout(context){
      context.commit('authState', false);
      router.push({name:'signin'})
    }
  },
  getters: {
    getIsUserLoggedIn(state) {
      return state.loggedIn;
    },
    getToken(state){
      return state.token
    }
  },
});
